import React, { useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import {
  CupomAndamento,
  CupomAndamentoInformation,
  CupomAndamentoTitle,
  CupomAndamentoDescription,
  SemanticTable,
} from "./styled";
import { Button, Dimmer, Icon, Loader, Modal } from "semantic-ui-react";
import swal from "sweetalert";

const ScrollingModal = (cupon) => {
  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState();
  const [cursoAlunos, setCursoAlunos] = React.useState([]);
  const [counter, setCounter] = React.useState();

  const loadData = async () => {
    try {
      setLoad(true);
      const params = {
        cupom: cupon.cupon,
      };

      const response = await api.get(`admin/cupons/relatorio`, { params });
      setCursoAlunos(response.data.cursoAlunosSimple);
      setCounter(response.data.counter);

      setLoad(false);
    } catch (err) {
      setLoad(false);
      console.error(err);
      swal("Não foi possível carregar os alunos deste cupom", "", "");
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={<Button onClick={loadData}>Mais informações</Button>}
    >
      <Modal.Header>{cupon.cupon}</Modal.Header>
      {load && (
        <Dimmer active>
          <Loader />
        </Dimmer>
      )}
      <Modal.Content image scrolling>
        <Modal.Description>
          <CupomAndamento>
            <CupomAndamentoInformation>
              <CupomAndamentoTitle>Total de cursos:</CupomAndamentoTitle>
              <CupomAndamentoDescription>
                {counter?.total ?? " "}
              </CupomAndamentoDescription>
            </CupomAndamentoInformation>
            <CupomAndamentoInformation>
              <CupomAndamentoTitle>Cursos em andamento:</CupomAndamentoTitle>
              <CupomAndamentoDescription>
                {counter?.running ?? " "}
              </CupomAndamentoDescription>
            </CupomAndamentoInformation>
            <CupomAndamentoInformation>
              <CupomAndamentoTitle>Cursos finalizados:</CupomAndamentoTitle>
              <CupomAndamentoDescription>
                {counter?.completed ?? " "}
              </CupomAndamentoDescription>
            </CupomAndamentoInformation>
            <CupomAndamentoInformation>
              <CupomAndamentoTitle>Cursos não iniciados:</CupomAndamentoTitle>
              <CupomAndamentoDescription>
                {counter?.notInitialized ?? " "}
              </CupomAndamentoDescription>
            </CupomAndamentoInformation>
          </CupomAndamento>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Nome do Aluno
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Email</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {Array.isArray(cursoAlunos)
                ? cursoAlunos.map((cursoAluno) => (
                    <SemanticTable.Row key={cursoAluno.nome + cursoAluno.curso}>
                      <SemanticTable.Cell>{cursoAluno.nome}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {cursoAluno.email}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {cursoAluno.curso}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {cursoAluno.status}
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))
                : null}
            </SemanticTable.Body>
          </SemanticTable>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} color="red">
          Fechar <Icon name="x icon" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ScrollingModal;
